import styles from './Button.module.scss'
import classNames from 'classnames/bind'

import Icon from '@/components/Icon/Icon'

const classes = classNames.bind(styles)

/**
 * @typedef {"primary" | "primary-animated" | "secondary" | "white-primary" | "white-gray" | "gray-light" | "error" | "error-light" | "warning" | "warning-light" | "text-primary" | "text-gray" | "text-white" } ButtonTypeProps
 * @typedef {"xl" | "lg" | "md" | "sm" | "xs"} SizeTypeProps
 */

/**
 * A simple button component.
 *
 * @component
 * @param {String} icon The icon to display.
 * @param {String} text The text to display.
 * @param {ButtonTypeProps} type The type of button to display.
 * @param {SizeTypeProps} size The size of the button.
 * @param {String} iconPosition The position of the icon.
 * @param {Boolean} square Whether the button is squared.
 * @param {Boolean} fullWidth Whether the button is full width.
 *
 * @param {Object} props Any other props to pass to the button.
 *
 * @returns {Component} The button component.
 *
 */
export default ({
    icon,
    text,
    size = 'md',
    type = 'primary',
    square = true,
    fullWidth,
    iconPosition,
    isLoading,
    ...props
}) => {
    return (
        <button
            {...props}
            className={classes(
                'button',
                type,
                size,
                {
                    text: type.includes('text-'),
                    'full-width': fullWidth,
                    square,
                    left: iconPosition == 'left',
                    loading: isLoading,
                    'icon-only': text == null,
                },
                props?.className
            )}
            disabled={isLoading || props.disabled}
        >
            {text && <span>{text}</span>}
            {icon && !isLoading && <Icon name={icon} className={classes('icon')} />}
            {isLoading && (
                <div className={classes('spinner')}>
                    <div className={classes('part')}></div>
                    <div className={classes('part')}></div>
                    <div className={classes('part')}></div>
                    <div className={classes('part')}></div>
                </div>
            )}
        </button>
    )
}
